module.exports = __webpack_public_path__ + "img/RS.f36afaba.png";